import { RefObject } from 'preact';
import { useEffect } from 'preact/hooks';
import { EnvironmentContext } from '../../UNSAFE_Environment';
import { useContext } from 'preact/hooks';

type UseHiddenTestMethodProps = {
  elementRef: RefObject<HTMLElement>;
  /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
  method: (...args: any[]) => void;
  name: string;
};

/**
 * This hook is used to add a hidden method to a component's root DOM element
 * that can be called by test adapters. The hidden method is only added when
 * we are not running in production mode, i.e. it's only used for testing.
 *
 * @param elementRef The ref to a component's root DOM element
 * @param method The hidden method to expose in the DOM
 * @param name The name of the hidden method in the DOM
 */
export function useHiddenTestMethod({ elementRef, method, name }: UseHiddenTestMethodProps) {
  const context = useContext(EnvironmentContext);

  // Add the hidden method to the DOM element only when mode !== production.
  useEffect(() => {
    if (elementRef.current && context.mode !== 'production') {
      /* eslint-disable-next-line @typescript-eslint/no-explicit-any */
      (elementRef.current as any)[name] = method;
    }
  }, [context.mode, elementRef, method, name]);
}
